<div class="main-container mat-typography mat-body">

  <a href="javascript:void(0)" class="show-hide-filters" (click)="toggleFilterDisplay()">
    @if (showFilters) {
      <div>
        <span>
          {{hideFilterContent || 'Hide Options'}}
        </span>
        <span class="material-symbols-outlined">expand_less</span>
      </div>
    }
    @if (!showFilters) {
      <div>
        <span>
          {{showFilterContent || 'Narrow Search Results'}}
        </span>
        <span class="material-symbols-outlined">expand_more</span>
      </div>
    }
  </a>

  <div [ngClass]="{ 'open': showFilters, 'closed': !showFilters }" class="filter-container">
    @for (filter of renderableMap | keyvalue; track filter) {
      <section class="filter-flex">
        <h3>{{renderableMap.get(filter.key).filterHeader}}</h3>
        <section class="filter">
          @for (option of renderableMap.get(filter.key).values; track option) {
            <div class="checkbox-container">
              <mat-checkbox (change)="toggleStateChange(filter.key, option)" [aria-label]="option.label" [checked]="option.checked">{{option.label}}</mat-checkbox>
            </div>
          }
        </section>
      </section>
    }
  </div>

</div>
